import { render, staticRenderFns } from "./representations.vue?vue&type=template&id=7a130b17&scoped=true&"
import script from "./representations.vue?vue&type=script&lang=js&"
export * from "./representations.vue?vue&type=script&lang=js&"
import style0 from "./representations.vue?vue&type=style&index=0&id=7a130b17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a130b17",
  null
  
)

export default component.exports